import React from 'react';

export const BomboraLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <rect width="64" height="64" rx="10" fill="#0A2540" />
    <path
      d="M8 40 Q16 28 24 36 Q32 44 40 32 Q48 20 56 28"
      stroke="#00BFA5"
      strokeWidth="4"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M8 48 Q16 36 24 44 Q32 52 40 40 Q48 28 56 36"
      stroke="#00E5C8"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
      opacity="0.6"
    />
    <circle cx="40" cy="32" r="5" fill="#00BFA5" />
  </svg>
);
